import { colorSystem, Flexbox, Text } from '@luminovo/design-system';
import type React from 'react';

/** The shared chart card and toolbar. Children fill the rest of the card and scroll themselves; the card clips. */
export function ChartFrame({
    title,
    controls,
    legend,
    children,
}: {
    title: React.ReactNode;
    controls?: React.ReactNode;
    legend?: React.ReactNode;
    children: React.ReactNode;
}) {
    return (
        <Flexbox
            style={{
                flex: 1,
                minHeight: 0,
                background: colorSystem.neutral.white,
                borderRadius: 8,
                border: `1px solid ${colorSystem.neutral[2]}`,
                overflow: 'hidden',
            }}
            sx={{
                flexDirection: 'column',
            }}
        >
            <Flexbox
                gap="12px"
                style={{
                    flexShrink: 0,
                    padding: '16px 16px 12px',
                    borderBottom: `1px solid ${colorSystem.neutral[2]}`,
                }}
                sx={{
                    alignItems: 'center',
                    flexWrap: 'wrap',
                }}
            >
                <Flexbox gap="8px" sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
                    <Text variant="h4">{title}</Text>
                    {controls}
                </Flexbox>
                <div style={{ flex: 1 }} />
                {legend}
            </Flexbox>
            {children}
        </Flexbox>
    );
}
